<template>
    <span class="m-r-10 ">
        <el-button
            @click="openDialog()"
            :disabled="disabledAdd"
            >
            Добавить папку
        </el-button>
        <el-dialog title="Подтвердите действие" :visible.sync="dialogTableVisible" :close-on-click-modal="false" width="500px">
            <el-form :model="form" :rules="rules" ref="form" label-position="left" label-width="150px" >
                <el-form-item label="Введите имя папки" prop="title">
                    <el-input size="small" v-model="form.title"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    size="mini"
                    @click="dialogTableVisible = false"
                >
                    Отменить
                </el-button>
                <el-button
                    size="mini"
                    type="primary"
                    @click="createCatalog"
                >
                    Сохранить
                </el-button>
            </span>
        </el-dialog>
    </span>
</template>

<script>

export default {
    data() {
        return {
            dialogTableVisible: false,
            form: {
                title: '',
            },
            rules: {
				title: [
					{ required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
				],
            }
        }
    },
    props: {
        catalogId: {
            default: null,
            type: Object
        },
        cheked: {
            default: null,
            type: Object
        },
    },
    computed: {
        disabledAdd() {
            if(this.cheked === null) {
                return false
            } else if(this.cheked.isFolder === true) {
                return false
            } else {
                return true
            }
        }
    },
    methods: {

        openDialog() {
            this.dialogTableVisible = true
            this.form.title = ''

        },

        async createCatalog() {
             
            this.$refs.form.validate(async (valid) => {
                if(valid) {
                    try {
                        let query = await this.$store.dispatch('documentCreateCatalog', {
                            parentId: this.cheked ?  this.cheked.id : null,
                            title: this.form.title,
                            sorting: null
                        })
                        this.$emit('addAppend', query)
                        this.dialogTableVisible = false
                    } catch(e) {
                        this.$ErrorsMod(e)
                    }
                }
            })
        }
           
        


    }
}
</script>



